import { updateLegacyReduxAction } from 'modules/redux/actions/legacy/update'
import { saveLegacyReduxAction } from 'modules/redux/actions/legacy/save'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { getObjectUtil } from 'packages/src'
import getIdReduxUtil from 'modules/redux/utils/get-id/index.js'

/**
 * Mark a notification as clicked.
 * @param  {Instance} instance
 * @returns {Function}
 */
function clickNotificationAction (instance) {
  return (dispatch, getState) => {
    const path = getPathReduxUtil(instance)
    const notification = getObjectUtil(getState(), path)

    // If it's already clicked, noop
    if (notification.data.clicked) {
      return
    }

    const key = 'clicked'
    const value = true
    dispatch(
      updateLegacyReduxAction({
        path,
        key,
        value
      })
    )

    dispatch(
      saveLegacyReduxAction({
        path,
        endpoint: `/notifications/${getIdReduxUtil(notification)}`
      })
    )
    //
    // dispatch(
    //   saveLegacyReduxAction({ path })
    // )
  }
}

export {
  clickNotificationAction
}
